// services/iiif.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError, tap } from 'rxjs/operators';
import { IIIFManifest, IIIFImage } from '../models/iiif.models';

@Injectable({
  providedIn: 'root'
})
export class IIIFService {
  private manifestCache = new Map<string, IIIFManifest>();

  constructor(private http: HttpClient) {}

  loadImage(url: string): Observable<IIIFImage> {
    const image = new IIIFImage(url);
    
    // Check cache first
    if (this.manifestCache.has(url)) {
      image.manifest = this.manifestCache.get(url);
      return of(image);
    }

    // Load manifest
    return this.http.get<IIIFManifest>(image.manifestUrl).pipe(
      tap(manifest => {
        // Cache the manifest
        this.manifestCache.set(url, manifest);
        image.manifest = manifest;
      }),
      map(() => image),
      catchError(error => {
        console.error('Failed to load IIIF manifest:', error);
        return of(image); // Return image without manifest
      })
    );
  }

  loadManifest(url: string): Observable<IIIFManifest> {
    return this.http.get<IIIFManifest>(`${url}/info.json`);
  }
}
